export var copyWebhookValue = function (value) { return navigator.clipboard.writeText(value); };
